require("!!/Volumes/Projects/Boongg/master/boongg-admin/node_modules/script-loader/addScript.js")(require("!!/Volumes/Projects/Boongg/master/boongg-admin/node_modules/raw-loader/index.js!/Volumes/Projects/Boongg/master/boongg-admin/node_modules/select2/dist/js/select2.full.min.js"))


//////////////////
// WEBPACK FOOTER
// /Volumes/Projects/Boongg/master/boongg-admin/~/script-loader!/Volumes/Projects/Boongg/master/boongg-admin/~/select2/dist/js/select2.full.min.js
// module id = ../../../../script-loader/index.js!../../../../select2/dist/js/select2.full.min.js
// module chunks = 47